import { render, staticRenderFns } from "./OrganizationPermissionSelector.vue?vue&type=template&id=26c4d034&"
import script from "./OrganizationPermissionSelector.vue?vue&type=script&lang=js&"
export * from "./OrganizationPermissionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports